export const HAZARDS = [
  { id: 1, type: 'Pothole', lat: 19.0760, lng: 72.8777, severity: 'High', city: 'Mumbai', verified: 12 },
  { id: 2, type: 'Accident', lat: 28.7041, lng: 77.1025, severity: 'Critical', city: 'Delhi', verified: 45 },
  { id: 3, type: 'Flooding', lat: 12.9716, lng: 77.5946, severity: 'Moderate', city: 'Bangalore', verified: 8 },
];

export const USER_PROFILE = {
  name: "Arjun Verma",
  role: "Citizen Scout",
  score: 850,
  badges: ["Top Reporter", "Guardian"],
  reports: 14
};